import React, { memo, useMemo, useRef } from 'react';
import styles from './index.module.scss';
// import { useHover } from 'ahooks';
import CMarkdown from "../chatComponents/CMarkdown";
import { CnImageViewer } from '@sto/cn-ui';
// import copy from 'copy-to-clipboard';

const Question = (props) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [fileSizes, setFileSizes] = React.useState<Record<string, string>>({});
  const [expanded, setExpanded] = React.useState(false); // 控制文件列表展开/折叠

  // 判断是否为图片文件
  const isImageFile = (url: string) => {
    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
    const ext = url.split('.').pop()?.toLowerCase()?.split('?')[0] || '';
    return imageExts.includes(ext);
  };

  // 根据文件URL获取对应的图标
  const getFileIcon = (url: string) => {
    const ext = url.split('.').pop()?.toLowerCase()?.split('?')[0] || '';
    const iconMap: Record<string, string> = {
      'ppt': 'https://imgcdn.sto.cn/82963C8E-2AC4-40-200x200-ppt.png',
      'pptx': 'https://imgcdn.sto.cn/82963C8E-2AC4-40-200x200-ppt.png',
      'doc': 'https://imgcdn.sto.cn/775EC0C7-4396-4E-200x200-WORD.png',
      'docx': 'https://imgcdn.sto.cn/775EC0C7-4396-4E-200x200-WORD.png',
      'xls': 'https://imgcdn.sto.cn/BD3490FA-C079-4B-200x160-excel-.png',
      'xlsx': 'https://imgcdn.sto.cn/BD3490FA-C079-4B-200x160-excel-.png',
      'csv': 'https://imgcdn.sto.cn/BD3490FA-C079-4B-200x160-excel-.png',
    };
    return iconMap[ext] || 'https://imgcdn.sto.cn/97F4A4A4-BDB9-4A-200x200-wenjian.png';
  };

  // 从 URL 中提取文件名
  const getFileName = (url: string) => {
    try {
      const urlWithoutParams = url.split('?')[0];
      const parts = urlWithoutParams.split('/');
      const fileName = parts[parts.length - 1];
      return decodeURIComponent(fileName);
    } catch {
      return '未知文件';
    }
  };

  // 获取文件类型标签
  const getFileTypeLabel = (url: string) => {
    const ext = url.split('.').pop()?.toLowerCase()?.split('?')[0] || '';
    if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext)) return 'Image';
    return ext.toUpperCase();
  };

  // 获取文件大小
  React.useEffect(() => {
    const fetchFileSizes = async () => {
      if (!props.fileUrls?.length) return;
      
      const sizes: Record<string, string> = {};
      for (const url of props.fileUrls) {
        try {
          const response = await fetch(url, { method: 'HEAD' });
          const size = response.headers.get('Content-Length');
          if (size) {
            const sizeNum = parseInt(size);
            if (sizeNum < 1024) {
              sizes[url] = `${sizeNum}B`;
            } else if (sizeNum < 1024 * 1024) {
              sizes[url] = `${Math.round(sizeNum / 1024)}KB`;
            } else {
              sizes[url] = `${(sizeNum / 1024 / 1024).toFixed(1)}MB`;
            }
          }
        } catch (error) {
          console.error('Failed to fetch file size:', error);
        }
      }
      setFileSizes(sizes);
    };

    fetchFileSizes();
  }, [props.fileUrls]);

  return (
    <div ref={ref}>
      <div className={styles.question}>
        <div className={styles.card}>
          {props.fileUrls?.length > 0 ? (
            <div className={styles.imgList}>
              {/* 渲染文件卡片的函数 */}
              {(() => {
                const maxDisplay = 2; // 最多显示2个
                const displayFiles = expanded ? props.fileUrls : props.fileUrls.slice(0, maxDisplay);
                const remainingCount = props.fileUrls.length - maxDisplay;

                return (
                  <>
                    {displayFiles.map((url, index) => {
                      const fileName = getFileName(url);
                      const fileType = getFileTypeLabel(url);
                      const fileSize = fileSizes[url];
                      
                      return (
                        <div
                          key={index}
                          onClick={() => window.open(url, '_blank')}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            padding: '6px 8px',
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            borderRadius: '6px',
                            maxWidth: '160px',
                            cursor: 'pointer',
                            transition: 'background-color 0.2s',
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)'}
                        >
                          {isImageFile(url) ? (
                            <CnImageViewer 
                              width={36} 
                              height={36} 
                              src={url}
                              style={{ 
                                flexShrink: 0,
                                borderRadius: 4,
                              }}
                            />
                          ) : (
                            <img 
                              src={getFileIcon(url)}
                              alt="file"
                              style={{ 
                                width: 36, 
                                height: 36, 
                                objectFit: 'cover',
                                borderRadius: 4,
                                flexShrink: 0,
                              }}
                            />
                          )}
                          <div style={{
                            flex: 1,
                            overflow: 'hidden',
                            minWidth: 0,
                          }}>
                            <div style={{
                              fontSize: '11px',
                              color: '#fff',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              fontWeight: 500,
                              lineHeight: '14px',
                            }}>
                              {fileName}
                            </div>
                            <div style={{
                              fontSize: '10px',
                              color: 'rgba(255, 255, 255, 0.7)',
                              marginTop: '2px',
                              lineHeight: '12px',
                            }}>
                              {fileType}{fileSize ? ` · ${fileSize}` : ''}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    {/* 展开/折叠按钮 */}
                    {!expanded && remainingCount > 0 && (
                      <div
                        onClick={() => setExpanded(true)}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '48px',
                          height: '48px',
                          backgroundColor: 'rgba(255, 255, 255, 0.1)',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          color: '#fff',
                          fontWeight: 500,
                          transition: 'background-color 0.2s',
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)'}
                      >
                        +{remainingCount}
                      </div>
                    )}
                  </>
                );
              })()}
            </div>
          ) : null}
          <CMarkdown content={props.context?.replace(/#/g, '\\#') || ''} />
        </div>
      </div>
      {/* <div className={styles.handler}>
        {isHovering ? (
          <>
            <CnIcon
              onClick={() => {
                copy(
                  props.context?.replace(/^[\s&nbsp;]+|[\s&nbsp;]+$/g, ''),
                ) && Message.success('复制成功');
              }}
              type="copy"
              size="large"
            />
          </>
        ) : null}
      </div> */}
    </div>

  );
};

export default memo(Question, (prevProps, nextProps) => {
  // 对特定的 prop 进行深度比较
  return prevProps.context === nextProps.context;
});
